<template>
  <div class="index-modular">
    <!-- <MyHeader></MyHeader> -->
    <HeaderUserInfo res="headerUserInfoModular" :number="cartNum"></HeaderUserInfo>
    <ShareRight></ShareRight>
    <router-view />

    <!-- <div class="footer-modualr"> -->
      <MyFooter></MyFooter>
    <!-- </div> -->
  </div>
</template>
<script>
import MyHeader from "../components/public/header";
import ShareRight from "../components/public/publicRight";
import MyFooter from "../components/public/footer";
import HeaderUserInfo from "../components/public/HeaderUserInfo";


export default {
  components: {
    MyHeader, ShareRight, MyFooter, HeaderUserInfo
  },
  data() {
    return {
      cartNum: 0
    }
  },
  methods: {
    /**
 * 更改购物车的数量
 */
    setHeaderCartNum(num) {
      let that = this;
      that.cartNum = num;
    },
    /**
     * 加入购物车
     * @param {*} product_id 
     * @param {*} sku_number 
     * @param {*} type 
     * @param {*} portfolio_sales_middle_id 
     * @param {*} cartNum 
     */
    addCart(product_id, sku_number, type, portfolio_sales_middle_id, cartNum) {

      let that = this;
      let data = {
        product_id: product_id,
        sku_number: sku_number,
        type: type,
        portfolio_sales_middle_id: portfolio_sales_middle_id,
        cartNum: cartNum,//购购物车数量
        cookie:that.getCookies()
      }
      this.$http.addCart(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // this.$refs.headerModular.shopCartNum ++;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);

        }
      )
    },

    /**
      * 
      * @param {*} id 
      * @param {*} type 0-加入收藏 1-取消收藏
      */
    productCollect(id, type, callback) {
      let that = this;
      let data = {
        product_id: id
      }
      let status = false;
      let collectAjaxUrl = this.$http.addCollect;
      if (type == 0) {
        // 加入收藏
        collectAjaxUrl = this.$http.addCollect;
      } else {
        // 取消收藏
        collectAjaxUrl = this.$http.cancelCollect;
      }
      collectAjaxUrl(
        data, callback, callback
        // (res) => {
        //   if (res.ret == 1) {
        //     this.$message.success(res.msg);
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // },
        // (res) => {
        //   this.$message.error(res.msg);
        // }
      )
    },

    /**
     * 获取购物车的数量
     */
    getCartNum() {
      let that = this;
      let status = false;
      this.$http.getCartNum(
        {
          cookie:that.getCookies()
        },
        (res) => {
          if (res.ret == 1) {
            that.setHeaderCartNum(parseInt(res.data.cartCount))
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      )
      return status
    },
        /**
     * 语言翻译 - 单个
     * @param {*} text
     * @param {*} callback
     * @param {*} errCallBack
     */
    translate(text, callback, errCallBack) {
      let that = this;
      let data = {
        text: text, //带翻译文本
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translate(data, callback, errCallBack);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     * @param {*} callback
     * @param {*} errCallBack
     */
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },
  },
  mounted() {
    let that = this;
    // 查询购物车数量
    that.getCartNum();
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/view/indexNoheader.vue